import styled from 'styled-components'

const ContainerSecondary = styled.div`
  width: 90%;
  margin: auto;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
`

export default ContainerSecondary
